import BuilderModel from "../../../../common/models/tracked/builderModel";

export default class PaymentLineItemAmount extends BuilderModel {
  payment_amount: number = 0;
  payment_amount_formula: string;
  skip_charge: boolean = false;

  get isCollectionRoot(): boolean {
    return false;
  }

  get paymentAmountString(): string {
    return (this.payment_amount / 100.0).toString();
  }
  set paymentAmountString(val) {
    this.payment_amount = Math.floor(parseFloat(val) * 100);
    if (isNaN(this.payment_amount)) {
      this.payment_amount = 0;
    }
  }

  get skipCharge(): boolean {
    return this.skip_charge;
  }
  set skipCharge(val) {
    this.skip_charge = val;
    if (val) {
      this.paymentAmountString = "0";
    }
  }
}